import { render, staticRenderFns } from "./Arrecadacao.vue?vue&type=template&id=76848dfc"
import script from "./Arrecadacao.vue?vue&type=script&lang=js"
export * from "./Arrecadacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports